<div [formGroup]="form">
    <mat-label class="font-style">
        <!-- Nearest Obstruction -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.NEAREST_OBSTRUCTION' | transloco }}
    </mat-label>

    <input
        class="input-form-class"
        matInput
        matTooltip="Nearest Obstruction is required."
        [matTooltipDisabled]="this.form.get('nearestObstruction').valid"
        name="nearest_obstruction"
        formControlName="nearestObstruction"
        (blur)="onBlurEvent($event)"
        [ngClass]="form.get('nearestObstruction').valid ? '' : 'highLight'"
    />
</div>
